<ng-container *ngIf="regionState$ | async as state">
  <header>
    <x-close-button (click)="regionService.closeOverlay()"></x-close-button>
    <div class="heading">
      <h2 class="text-capitalize">
        <ng-container i18n="@@RegionOverlay.ConfirmDeliveryArea.Title">
          Confirm your delivery area
        </ng-container>
      </h2>
      <div
        class="sub-heading mat-body-2"
        i18n="@@RegionOverlay.AddToCartFlow.ConfirmDeliveryArea.SubTitle"
      >
        This product can only be shipped to certain areas, please enter your address?
      </div>
    </div>
  </header>

  <div class="body-content">
    <x-region-search></x-region-search>
    <x-region-add-to-cart-detail></x-region-add-to-cart-detail>
  </div>
</ng-container>
